module.exports = __webpack_public_path__ + "media/images/covers/starworks-weekly-sept24-bg-mobile-15d29b6396e9dbf2275269ea4a128c79.png";